import { Popper } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { setFilter, setSelectedOptions } from '../../../store/features/moments/momentsSlice';

const FilterBox = () => {
    const { words } = useAppSelector(state => state.localization);
    const { specialNameList } = useAppSelector(state => state.moments);
    const [checkboxValue, setCheckBoxValue] = useState<any>([]);
    const dispatch = useDispatch();
    const { filter,selectedOptions } = useAppSelector(state => state.moments);

    const filterMultiSelectBox = () => {
        if (selectedOptions.length > 0) {           
            const selectedValue = selectedOptions.map(item => item.value);
            setCheckBoxValue(selectedValue[0] + `${selectedValue.length > 1 ? ',' + selectedValue[1] : ''}`);
            dispatch(
                setFilter({
                    ...filter,
                    specialDateType: selectedOptions.map(x => x.key).join(';'),
                }),
            );
        }
    };

    useEffect(() => {
        filterMultiSelectBox();
    }, [selectedOptions]);

    const handleChange = (e, value) => {
        dispatch(setSelectedOptions(value))
    };

    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const CustomPopper = function (props) {
        return <Popper {...props} className="modal-03 " placement="bottom" />;
    };

    return (
        <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            PopperComponent={CustomPopper}
            value={selectedOptions}
            options={specialNameList?.items}
            renderTags={() => null}
            disableCloseOnSelect
            noOptionsText={words && words['WEB.resultNotFounded']}
            closeIcon=""
            onChange={(e,val)=>handleChange(e,val)}
            className={selectedOptions.length > 0 ? 'select-05 border-orange' : 'select-05'}
            getOptionLabel={(option: any) => option && option.value && option.value}
            renderOption={(option: any, { selected }) => (
                <div className="select-box-container">
                    <Checkbox color="primary" id="checkbox-ids" checkedIcon={checkedIcon} checked={selected} />
                    {option.value}
                </div>
            )}
            renderInput={params => (
                <>
                    {selectedOptions.length > 0 && (
                        <label className={selectedOptions.length > 0 ? 'input-filter-label' : 'input-filter-label active'} htmlFor="input-filter-text">
                            {selectedOptions.length > 0 ? checkboxValue : words && words['WEB.filters']}
                        </label>
                    )}
                    <TextField
                        id="input-filter-text"
                        {...params}
                        className="select-textfield"
                        placeholder={selectedOptions.length === 0 ? words && words['WEB.filters'] : ''}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <svg className="select-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 9L12 15L18 9" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            ),
                        }}
                    />
                </>
            )}
        />
    );
};

export default FilterBox;
